/* View-only adaptive empty-option text. Never changes option values or selection. */
(() => {
  'use strict';
  const field=document.querySelector('[data-jlse-province]');
  const configNode=document.getElementById('JetLifeShippingConfig');
  if(!field || !configNode || window.JetLifeEstimatorFit) return;
  let config;
  try { config=JSON.parse(configNode.textContent); } catch(_) { return; }
  const originals=new WeakMap(), canvas=document.createElement('canvas'), ctx=canvas.getContext('2d');
  let frame=0;
  const schedule=()=>{if(!frame)frame=requestAnimationFrame(update);};
  function update(){
    frame=0;
    const empty=[...field.options].find(o=>o.value==='');
    if(!empty)return;
    if(!originals.has(empty))originals.set(empty,empty.textContent);
    const original=originals.get(empty), style=getComputedStyle(field);
    if(ctx)ctx.font=style.font;
    const available=field.clientWidth-(parseFloat(style.paddingLeft)||0)-(parseFloat(style.paddingRight)||0)-24;
    const compact=innerWidth<=600 || (ctx&&ctx.measureText(original).width>available);
    const text=compact?(config.mobilePlaceholder||'Select'):original;
    if(empty.textContent!==text)empty.textContent=text;
  }
  window.JetLifeEstimatorFit=Object.freeze({version:'1.0.0'});
  new MutationObserver(schedule).observe(field,{childList:true,subtree:true});
  if(window.ResizeObserver)new ResizeObserver(schedule).observe(field);
  document.fonts?.ready.then(schedule);
  addEventListener('resize',schedule);
  schedule();
})();
